import { TLC_CONSTANTS } from "../../../../js/lib/tlc-constants";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";
import { LS2PacSearchDatabaseManager } from "../managers/SearchDatabaseManager";

export const FacetsClientManager = (function ($) {

	var restUrl = "facets",
		countToGet = 6;

	var facetData = {},
		resetData = function () {
			facetData = {
				needFacets:  true,
				facetResults:[]
			};
			TLCLogger.log("facets:data reset", facetData);
		};

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onSearch, function (event) {
		resetData();
	});
	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onSetAudience, function (event) {
		resetData();
	});
	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onFireAdvancedSearch, function (event) {
		resetData();
	});

	TLCEventManager.addListener(TLC_CONSTANTS.Events.onPagingModelResponse, function (event) {
		if (LS2PacSearchDatabaseManager.getCurrentDatabaseConfig().hasFacets) {
			if (event.success && event.data.hasFacets) {
				facetData.facetFilters = event.data.facetFilters;
				onGetFacetResults();
			}
		}
	});

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onChangeBranchLimits, function (event) {
		resetData();
	});

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onAddFacetFilterToResults, function (event) {
		resetData();
	});

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onRemoveFacetFilter, function (event) {
		resetData();
	});

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onSwitchSearchDatabase, function (event) {
		resetData();
	});

	var onGetFacetResults = function () {
		if (facetData.needFacets === true) {
			TLCRest.jsonCall(restUrl + "/getFacetResults", {
				callback:   function (facetResults) {
					facetData.facetResults = facetResults;
					facetData.resultsError = false;
					facetData.needFacets = false;

					if (facetData.facetResults.length > 0) {
						$.each(facetData.facetResults, function (index, facet) {
							facet.facetDisplayName = ApplicationData.language[facet.facetDisplayName] || facet.facetDisplayName;
							facet.facetNameLowerCase = facet.facetName.toLowerCase()
						});

						facetData.facetResults[0].expand = true;
					}

					TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onGetFacetResultsResponse, {success:true, data:facetData});
				},
				cache:	  false,
				cancellable:true
			});
		}
	};

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onGetMoreFacetResults, function (event) {
		onGetMoreFacetResults(event.facet);
	});

	var onGetMoreFacetResults = function (facet) {
		if (facet.facetValues === null) {
			facet.facetValues = [];
			facet.expand = true;
		}
		var start = facet.facetValues.length;
		TLCRest.jsonCall([restUrl, "getMoreFacetResults", facet.facetName, start, countToGet].join("/"), {
			callback:function (facetResults) {
				TLCLogger.log("FACET_RESULTS", facetResults);
				facet.moreResults = facetResults.moreResults;
				//(facetResults.facetValues.length == countToGet && (facet.facetValues.length >= facet.totalValueCount && facet.moreResults));
				if (facetResults.facetValues.length < countToGet) {
					facet.moreResults = false;
				}
				facet.facetValues = facet.facetValues.concat(facetResults.facetValues);
				TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onGetMoreFacetResultsResponse, {success:true, data:facet});
			},
			cache:	  false,
			cancellable:true
		});
	};


	return {
		getFacetData:function () {
			return facetData;
		}
	};

})(jQuery);
